import React, { FC } from "react";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import PageTemplate from "../../../components/Layout/Common/PageTemplate";
import { PrivateUIRoutes } from "../../../router";
import List from "../../../components/Indices/List";

const IndicesList: FC = () => {
  const navigate = useNavigate();

  const createHandler = () => {
    navigate(
      `/${PrivateUIRoutes.CONTROL_PANEL}/${PrivateUIRoutes.CREATE_INDICES}`
    );
  };

  return (
    <PageTemplate
      title={"Indices"}
      extra={<Button onClick={createHandler}>CREATE</Button>}
    >
      <List />
    </PageTemplate>
  );
};

export default IndicesList;
